import React from 'react'
import { useParams } from 'react-router-dom'
import ProjectDetailUI from '../../components/core-ui/project-detail/project-detail-ui'
import { findBySlug, neighbours, related } from '../../utils/projectSlug'

function ProjectDetailPage() {
    const { slug } = useParams()
    const entry = findBySlug(slug)

    return (
        <ProjectDetailUI
            slug={slug}
            project={entry ? entry.project : null}
            neighbours={entry ? neighbours(slug) : { previous: null, next: null }}
            related={entry ? related(slug) : []}
        />
    )
}

export default ProjectDetailPage
